export default __webpack_public_path__ + "ffbaf727ba85a3f1ca333b639c56cfee.png";